const DeliveryTruckReportIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2147_40925)" />
      <g clip-path="url(#clip0_2147_40925)">
        <path
          d="M35.4004 32.5705C35.5387 32.8807 35.7005 33.1798 35.8844 33.4652L50.3671 30.5839C49.7768 28.5095 48.7719 26.5764 47.4132 24.9015C46.0544 23.2265 44.3701 21.8446 42.4621 20.8391C40.5541 19.8337 38.4619 19.2257 36.3122 19.0519C34.1625 18.8781 31.9999 19.142 29.9551 19.8279L35.4004 32.5705Z"
          fill="white"
        />
        <path
          d="M35.8413 37.3225C34.5784 36.3562 33.583 35.0836 32.9493 33.6252L27.5026 20.8745C25.4367 21.9658 23.6351 23.4967 22.2246 25.3594C20.8141 27.222 19.8289 29.3712 19.3385 31.6556C18.8482 33.94 18.8644 36.3041 19.3862 38.5816C19.9079 40.8591 20.9225 42.9945 22.3585 44.8376C23.7945 46.6806 25.617 48.1866 27.6977 49.2494C29.7785 50.3122 32.0669 50.9061 34.4018 50.9892C36.7368 51.0723 39.0616 50.6426 41.2126 49.7303C43.3637 48.8181 45.2886 47.4455 46.852 45.7092L35.8413 37.3225Z"
          fill="white"
        />
        <path
          d="M38.1538 35.7321L48.4751 43.5987C50.1246 41.0342 51.0012 38.0492 51.0005 35.0001C50.9982 34.3981 50.9622 33.7967 50.8925 33.1987L38.1538 35.7321Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2147_40925"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F36636" />
          <stop offset="1" stop-color="#D84800" />
        </linearGradient>
        <clipPath id="clip0_2147_40925">
          <rect width="32" height="32" fill="white" transform="translate(19 19)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DeliveryTruckReportIconSubcategory
